import { createMuiTheme } from '@material-ui/core'

// TODO: Create a custom DCS Unity theme based on user permission
export const createUnityTheme = (_isAdmin) => createMuiTheme({})
